import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { combineLatest,firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { QualificationEntity } from '../../dave-data-module/entities/mdqx/doctor/qualification.entity';
import { MutationCreateQualificationArgs } from '../../dave-data-module/mdqx-graphql-types';
import { HttpService } from '../../dave-data-module/services/http.service';
import { State } from '../../dave-data-module/State';
import { BaseActionTypes } from '../../dave-data-module/State/actions/base.actions';
import { getToken } from '../../dave-data-module/State/selectors/base.selectors';
import { QualificationActions } from '../../dave-data-module/State/actions/mdqx/doctor/qualification.actions';

enum ErrorCodes {
    Get = 'Qualifikationen Abrufen fehlgeschlagen',
    Post = 'Qualifikation Anlegen fehlgeschlagen',
    Patch = 'Qualifikation Bearbeiten fehlgeschlagen',
    Delete = 'Qualifikation Löschen fehlgeschlagen',
}

@Injectable({
    providedIn: 'root',
})
export class QualificationDataService {
    constructor(private store: Store<State>, private actions$: Actions, private api: HttpService) {}
    async createQualificationOptions(names: string[]) {
        try {
            const ret = await this.mutationAddQualifications(names.map<MutationCreateQualificationArgs>((name) => ({ name })));
            this.store.dispatch(QualificationActions.putSuccess({
                Payload: ret,
            }))
            return ret;
        } catch (err) {
            this.store.dispatch(
                QualificationActions.putFailure({
                    ToasterMessage: ErrorCodes.Post,
                    Errors: err,
                }),
            );
        }
    }

    async mutationAddQualifications(payload: MutationCreateQualificationArgs[]) {
        const query = (payload: MutationCreateQualificationArgs) => `mutation {
        createQualification(name: "${payload.name}") {${QualificationEntity.GqlFields.join(' ')}}
      }
      `;
        const token = await firstValueFrom(this.store.select(getToken));

        return firstValueFrom(
            combineLatest(
                payload.map((p) =>
                    this.api.graphQl({ query: query(p) }, { token }, '', environment.mdqxGatewayApiUrl).pipe(
                        map((res) => {
                            if (!res?.createQualification) {
                                throw 'broken response';
                            }
                            return QualificationEntity.fromBackend(res.createQualification);
                        }),
                    ),
                ),
            ),
        );
    }
}
